import { TableHeadersType } from "../tableHeadersType";

export const ASSIGNED_USERS_OF_SINGLE_CLIENT_HEADERS: TableHeadersType[] = [
  {
    label: "NAME",
    value: "name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "EMAIL",
    value: "email",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "USER TYPE",
    value: "user_type",
    defaultChecked: true,
    checked: true,
  },
];
